@if (isLoading()) {
  <app-spinner data-test-id="step-challenge-leaderboard-spinner"></app-spinner>
} @else {
  <app-card [size]="'large'" [fullHeight]="true" [spacingBottom]="Spacing.NONE">
    <app-title-section
      title="{{ challenge()?.name }}"
      [size]="3"
      [backButton]="true"
      [spacingBottom]="TitleSpacing.LARGE"
      (handlePressBack)="goBack()"
      data-test-id="step-challenge-leaderboard-back"
    />
    <app-text
      [type]="TextType.BODY"
      [size]="TextSize.TITLE_1"
      [height]="TextHeight.TITLE_3"
      [weight]="TextWeight.REGULAR"
      [color]="TextColor.NEUTRAL_8"
      [spacingBottom]="TextSpacing.SMALL"
    >
      {{ team()?.rank }}{{ getOrdinalSuffix(team()?.rank) }}
    </app-text>
    <app-text
      [type]="TextType.TITLE"
      [size]="TextSize.TITLE_3"
      [height]="TextHeight.TITLE_3"
      [weight]="TextWeight.BOLD"
      [color]="TextColor.NEUTRAL_8"
      [spacingBottom]="TextSpacing.MEDIUM"
    >
      {{ team()?.name }}
    </app-text>
    <ul data-test-id="step-challenge-leaderboard-members-list">
      @for (member of members(); track $index) {
        <li
          [style.background]="$index === 0 ? team()?.color : '#fff'"
          data-test-id="step-challenge-leaderboard-member-item"
        >
          <p class="member-rank">
            {{ member.rank }}
          </p>
          <app-view [direction]="ViewDirection.COLUMN" [gap]="ViewSpacing.X_SMALL">
            <p class="member-name">
              {{ member.name }}
            </p>
            <p class="member-score">{{ member.score }} points</p>
          </app-view>
        </li>
      }
    </ul>
  </app-card>
}
